<script>
import axios from 'axios';
import { permissions } from '@/constants';
import IconFileUpload from '@/components/icons/FileUpload';
import IconExternalLink from '@/components/icons/ExternalLink';
import IconGhost from '@/components/icons/Ghost';

const settingsKey = 'common.orgStructureFile';

export default {
  computed: {
    settings () { return this.$store.state.settings.values; },
    src () { return this.settings[settingsKey]; },
    shouldRenderIframe () {
      if (!this.src) {
        return false;
      }

      return (
        this.src.endsWith('.pdf')
        || this.src.endsWith('.png')
        || this.src.endsWith('.jpg')
        || this.src.endsWith('.jpeg')
        || this.src.endsWith('.svg')
      );
    },

    hasWritePermissions () {
      const checkPermission = this.$store.getters['auth/checkPermission'];

      return checkPermission(permissions.FILE_WRITE)
        && checkPermission(permissions.SETTINGS_WRITE);
    },
  },
  methods: {
    async handleFileUpload (e) {
      if (!this.hasWritePermissions) {
        return;
      }

      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      const response = await axios.post(
        '/api/file',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      const file = response.data.data;

      await axios.post('/api/settings', {
        key: settingsKey,
        value: file.publicPath,
      });
      await this.$store.dispatch('settings/fetch');
    },
  },
  render () {
    const {
      $style,
      src,
      hasWritePermissions,
      shouldRenderIframe,
    } = this;

    return (
      <div>
        <u-title
          level="2"
          class="page-header"
        >
          <span>
            Орг. структура
          </span>

          <span class={$style.actions}>
            {Boolean(src) && (
              <a
                href={src}
                class="u-btn u-btn_outline u-btn_square u-btn_primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconExternalLink />
              </a>
            )}
            {hasWritePermissions && (
              <label
                class="u-btn u-btn_outline u-btn_square u-btn_primary"
              >
                <input
                  type="file"
                  class={$style.hiddenInput}
                  onChange={this.handleFileUpload}
                />
                <IconFileUpload />
              </label>
            )}
          </span>
        </u-title>

        {shouldRenderIframe && (
          <iframe
            class={$style.iframe}
            src={src}
            title="Орг. структура"
          />
        )}

        {!src && (
          <div class={$style.empty}>
            <span class={$style.emptyIcon}>
              <IconGhost />
            </span>
            <span>
              Файл не загружен
            </span>
          </div>
        )}
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.actions {
  margin-left: auto;

  & > * + * {
    margin-left: .5em;
  }
}

.hiddenInput {
  height: .125rem;
  opacity: 0;
  position: absolute;
  width: .125rem;
}

.iframe {
  border: 0;
  height: 30rem;
  width: 100%;
}

.empty {
  align-items: center;
  color: $color-gray;
  display: flex;

  &Icon {
    color: $color-gray-lighter;
    font-size: 4em;
    margin-right: .5em;
  }
}
</style>
